/* eslint-disable no-param-reassign */
// import getData from '@cms/api';

const postParentLead = (info) => (dispatch) =>
  dispatch({
    type: 'PARENT_LEAD',
    endpoint: `v1/user/parent_lead/add/?goal_uid=${info.goal_uid}`,
    method: 'post',
    data: JSON.stringify(info)
  });

export const getClassBookedInfo = (goalUid) => (dispatch) =>
  dispatch({
    type: 'CBSE_CLASS_BOOKED',
    endpoint: `v1/uplus/special_class/booked_item/?goal_uid=${goalUid}`,
    method: 'get'
  });

export const getAvailableClasses = (goalUid, query) => (dispatch) => {
  let endpoint = `v1/uplus/special_class/book_items/?goal_uid=${goalUid}`;
  if (query) {
    endpoint += `&${query}`;
  }
  return dispatch({
    type: 'BOOK_A_CLASS_TOPIC_GROUPS',
    endpoint,
    method: 'get'
  });
};

export const getTopicGoups = (goalUid) => (dispatch) =>
  dispatch({
    type: 'BOOK_A_CLASS_TOPIC_GROUPS',
    endpoint: `v1/topology/goal/topic_groups/?goal_uid=${goalUid}`,
    method: 'get'
  });

export const bookClass = (goalUid) => (dispatch) => {
  const formData = new FormData();
  formData.append('object_uid', goalUid);
  return dispatch({
    type: 'BOOK_A_CLASS',
    endpoint: 'v1/uplus/special_class/book_item/',
    method: 'POST',
    data: formData,
    isFormData: true
  });
};

const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

const weekNames = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

export const getDay = (someDate) => {
  const today = new Date();
  let dayName = '';
  if (
    someDate.getDate() === today.getDate() &&
    someDate.getMonth() === today.getMonth() &&
    someDate.getFullYear() === today.getFullYear()
  ) {
    dayName = 'Today';
  } else if (
    someDate.getDate() === today.getDate() + 1 &&
    someDate.getMonth() === today.getMonth() &&
    someDate.getFullYear() === today.getFullYear()
  ) {
    dayName = 'Tomorrow';
  } else dayName = weekNames[someDate.getDate()];
  return dayName;
};

export const getDate = (data) => new Date(data);

export const normalizeClasses = (data, prevData = []) => {
  const mergedData = [...prevData, ...data];
  const result = mergedData.reduce((acc, _data) => {
    const date = getDate(_data.starts_at);
    const modifiedDate = `${monthNames[date.getMonth()]} ${date.getDate()}`;
    const title = `${getDay(date)} ${modifiedDate}`;
    if (acc[title]) {
      acc[title] = [...acc[title], _data];
    } else {
      acc[title] = [_data];
    }
    return acc;
  }, {});

  return Object.keys(result).reduce((acc, value) => {
    const [title, ...subTitle] = value.split(' ');
    acc.push({ title, subTitle: subTitle.join(' '), data: result[value] });
    return acc;
  }, []);
};

export default postParentLead;
